// Reportes de Cotizaciones

import React, { useState, useEffect } from 'react';
import { Button, Box, Grid, Paper, Typography } from '@mui/material';
import { format, subDays } from 'date-fns';
import { apiFetchJson } from "../fetchWrapper";
import { formatMX } from '../util/DateUtil';
import jsPDF from "jspdf";
import DownloadIcon from '@mui/icons-material/Download';

export default function ReportQuotations() {
  const [loading, setLoading] = useState(true);
  const [report, setReport] = useState(null);
  const [startDate, setStartDate] = useState(subDays(new Date(), 7));
  const [endDate, setEndDate] = useState(new Date());

  const handleExport = () => {
    const doc = new jsPDF();

    doc.setFontSize(16);
    doc.text("Reporte de Cotizaciones", 14, 20);

    doc.setFontSize(10);
    doc.text(`Periodo: ${formatMX(startDate)} - ${formatMX(endDate)}`, 14, 30);

    doc.setFontSize(12);


    [
      { label: 'Cotizaciones Totales', value: report?.totalQuotations ?? 0 },
      { label: 'Promedio Elementos', value: report?.avgElements?.toFixed(1) ?? 0 },
      { label: 'Nuevas', value: report?.statuses?.find(s => s.status === 'PENDING' || s.status === 'NEW')?.total ?? 0 },
      { label: 'Aprobadas', value: report?.statuses?.find(s => s.status === 'APPROVED')?.total ?? 0 },
      { label: 'Rechazadas', value: report?.statuses?.find(s => s.status === 'REJECTED')?.total ?? 0 },
    ].map((card, i) => {
      const y = 40 + i * 10;
      doc.text(`${card.label}: ${card.value}`, 14, y);
    });

    doc.save("reporte-cotizaciones.pdf");
  };

  useEffect(() => {
    const fetchReport = async () => {
      setLoading(true);

      try {
        const start = format(startDate, "yyyy-MM-dd");
        const end = format(endDate, "yyyy-MM-dd");

        const data = await apiFetchJson(
          `/api/reports/quotations?startDate=${start}&endDate=${end}`
        );

        setReport(data);
        console.log("Report data", data);
      } catch (err) {
        console.error("Failed to load report", err);
      } finally {
        setLoading(false);
      }
    };
    fetchReport();
  }, [startDate, endDate]);

  return (
    <Box id="report-operations">

      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, mr: 5 }}>
        <Typography variant="h6">Cotizaciones</Typography>

        <Button
          variant="outlined"
          startIcon={<DownloadIcon />}
          onClick={handleExport}>
          Exportar PDF
        </Button>
      </Box>

      <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
        <Button
          variant="outlined"
          onClick={() => {
            setStartDate(subDays(new Date(), 7));
            setEndDate(new Date());
          }}
        >
          Últimos 7 días
        </Button>

        <Button
          variant="outlined"
          onClick={() => {
            setStartDate(subDays(new Date(), 30));
            setEndDate(new Date());
          }}
        >
          Últimos 30 días
        </Button>

        <Typography>
          {format(startDate, 'yyyy-MM-dd')} → {format(endDate, 'yyyy-MM-dd')}
        </Typography>
      </Box>

      {/*Cards */}
      <Grid container spacing={2} sx={{ mb: 3, mr: 1 }}>
        {[
          { label: 'Cotizaciones Totales', value: report?.totalQuotations ?? 0 },
          { label: 'Promedio Elementos', value: report?.avgElements?.toFixed(1) ?? 0 },
          { label: 'Nuevas', value: report?.statuses?.find(s => s.status === 'PENDING' || s.status === 'NEW')?.total ?? 0 },
          { label: 'Aprobadas', value: report?.statuses?.find(s => s.status === 'APPROVED')?.total ?? 0 },
          { label: 'Rechazadas', value: report?.statuses?.find(s => s.status === 'REJECTED')?.total ?? 0 },
        ].map((card, i) => (
          <Grid
            item
            xs={12}
            sm={6}
            md
            key={i}
            sx={{ flexGrow: 2 }}
          >
            <Paper sx={{ p: 2, height: '100%' }}>
              <Typography variant="subtitle2">{card.label}</Typography>
              <Typography variant="h5">{card.value}</Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}